import Message from '../src/Message/index';
export default Message;
